/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { Avatar } from "./Avatar";
import { StyledText } from "../assets/typography/typography";
import { colors } from "./colors";
import { Divider } from "./Divider";

type Props = {
  showDivider: boolean;
  file?: File;
  avatarPlaceholderText: string;
  title?: string;
  children: React.ReactNode;
};

const wrapperStyle = css`
  display: flex;
  flex-direction: row;
  padding: 16px 24px;
  gap: 8px;
`;

const columnStyle = css`
  display: flex;
  width: 100%;
  flex-direction: row;
  align-items: start;
  gap: 16px;
`;

const titleAndAvatarWrapperStyle = css`
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
`;

export const TwoColumnedRowWithAvatar = ({
  showDivider,
  file,
  avatarPlaceholderText,
  title,
  children,
}: Props) => {
  return (
    <>
      <div css={wrapperStyle}>
        <div css={columnStyle}>
          <div css={titleAndAvatarWrapperStyle}>
            <Avatar file={file} size="medium">
              {avatarPlaceholderText}
            </Avatar>
            <StyledText
              color={colors.textPrimary}
              className="bodyTextSemibold mb-0"
            >
              {title}
            </StyledText>
          </div>
        </div>
        <div css={columnStyle}>{children}</div>
      </div>
      {showDivider && <Divider />}
    </>
  );
};
